import React, { useEffect, useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './../styles/Checkout.scss'
import bag from './../../assets/bag.svg';
import useCartStore from './../store/cartStore'; 
import useUserStore from '../store/userStore'; 
import { useLoadingStore } from '../store/loadingStore';
import useToastStore from '../store/toastStore';
import { CartItemDTO } from '../types/Cart';
import CustomerInfo from '../components/Checkout/CustomerInfo';
import { createOrder, createOrderLine } from '../types/Order';
import { Customer, CustomerBranch } from '../types/Customer';
import { executeFetch, executePost } from '../helper/Api';
const Checkout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [customer,setCustomer] = useState<Customer>(null)
  const [selectedBranch,setSelectedBranch] = useState<CustomerBranch>(null);
  const {  isAuthenticated,user} = useUserStore(); 
  const {setLoading} = useLoadingStore();
  const { cart, removeFromCart,getCart,updateCart } = useCartStore();
  const {showToast} = useToastStore();
  const [editingItem, setEditingItem] = useState<{id: string, quantity: number} | null>(null);

  const transportFee = 7;

const sum = useMemo(() => {
  return cart.reduce((total, item) => total + item.price * item.quantity, 0);
}, [cart]);

const totalSum = useMemo(() => sum + transportFee, [sum]);

  const handleRemoveItem = async (id: string) => {
    setLoading(true);
    try{
      await removeFromCart(id);
      showToast('Cart updated!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
      console.error(error.message);
    }
    setLoading(false);
  };

  const handleUpdateItem = async (item : CartItemDTO) => {
    if (!editingItem || editingItem.id !== item.id) return;
    setLoading(true);
    try{
      await updateCart({...item, quantity: editingItem.quantity});
      showToast('Cart updated!','success')
    }
    catch(error){
      showToast('Error product to cart!','error')
      console.error(error.message);
    }
    setLoading(false);
  }
  
  const handleBranchChange = (branch : CustomerBranch) => {
    setSelectedBranch(branch);
  }

  const handlePlaceOrder = async () => {
     if(!selectedBranch){
        showToast('Please select Branch!','error');
        return;
     }
     if(!customer){
        showToast('Please login in order to place Order!','error');
        return ;
     }

    const order = createOrder(customer.id,customer.tid,selectedBranch.id,customer.tsid);
    order.lines = cart?.map(item => createOrderLine(0,item.productId,item.quantity,item.price))
    setLoading(true);
    const res = await executePost('Order/SetOrder',order,{auth:'auth'});
    setLoading(false);
    if(res.error){
     
        showToast('Something went wrong placing the order!','error');
        console.error(res.error.message);
    }else{
        showToast('Successfully placed the order!','success');
    }

  
  }
const fetchCustomer = async () => {
        setLoading(true);
        try {
            const resp = await executeFetch<Customer>(`Customer/GetCustomerInfo`,{auth:'auth'})
          if(resp.error){
              console.error(resp.error.message);
          }else{
            setCustomer(resp.data);
          }
        } catch (error) {
            setLoading(false);
          console.error("Error fetching Customer:", error);
        }
        setLoading(false);
    }



  useEffect(()=>{
    const fetchCart = async()=>{
        setLoading(true);
      await getCart();
      await  fetchCustomer();
      setLoading(false);
    }
    fetchCart();
  },[user,getCart])



  
  return (
    <>
    <div className='checkout-wrap'>
    <div className='checkout-info'>
        <CustomerInfo customer={customer} selectedBranch={selectedBranch} setSelectedBranch={handleBranchChange}/>
    </div>
      {/* Cart Sidebar */}
        <div className="checkout-cart">
          {/* Cart Items List */}
          <div className="cart-items">
            {cart.length > 0 ? (
              cart.map((item) => (
                <div key={item.sku} className="cart-item">
                    <button
                    className="remove-btn"
                    onClick={() => handleRemoveItem(item?.id)}
                    >
                    <FontAwesomeIcon icon={faCircleXmark} />
                  </button>
                    <div className='product'>
                        <img
                        src={item.image}
                        alt={item.name}
                        className="product-banner"
                        />
                        <div className="product-details">
                            <div className="product-title">{item.name}</div>
                            <div className="product-sku">SKU: {item.sku}</div>
                        </div>
                        <div className="productPrices">
                            <div className="product-price">
                                {item.price} €
                            </div>
                            <div className="product-quantity">Quantity:
                                    <input
                                      type="number"
                                      
                                      value={editingItem?.id === item.id ? editingItem.quantity : item.quantity}
                                      onChange={(e) => setEditingItem({
                                        id: item.id,
                                        quantity: parseInt(e.target.value) || 1
                                      })}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          handleUpdateItem(item);
                                        }
                                      }}
                                      onBlur={() => handleUpdateItem(item)}
                                      placeholder="Enter destination URL"
                                      className="index-input"
                                    />
                                    </div>
                        </div>
                    </div>
                  
                
                </div>
              ))
            ) : (
              <p className="empty-cart">Your cart is empty.</p>
            )}
          </div>

          {/* Cart Footer */}
          <div className="cart-footer">
            <div className='cf-title'>TOTAL</div>
            <div className='subtotals'>
                <div className='sub'>
                Subtotal: <span>{sum.toFixed(2)} €</span>
                </div>
                <div className='sub'>
                Transport Fee: <span>{transportFee.toFixed(2)} €</span>
                </div>
            </div>
            <div className="total-sum">
              Total: <span>{totalSum.toFixed(2)} €</span>
            </div>
            <button 
            onClick={handlePlaceOrder}
            disabled={!isAuthenticated}
            className="place-order-btn">Place Order</button>
          </div>
        </div>
      
    </div>
    </>
  );
};

export default Checkout;